import React from 'react';

import HorizontalThrobber from 'ui-library/HorizontalThrobber';

import WorkflowDashboardTemplateTable from './components/WorkflowDashboardTemplateTable';
import {WorkflowTemplate} from './WorkflowConstants';

export default function WorkflowDashboardTemplatesScreen({
  workflowTemplates,
}: {
  workflowTemplates?: Array<WorkflowTemplate> | null;
}): JSX.Element {
  return (
    <div className="u-flex-full-height">
      {workflowTemplates ? (
        <WorkflowDashboardTemplateTable workflowTemplates={workflowTemplates} />
      ) : (
        <div className="text-center">
          <HorizontalThrobber />
        </div>
      )}
    </div>
  );
}
